<template>
  <div :class="$style.wrapper">
    <div v-if="!isReadOnlyMode" class="p-field-checkbox" :class="$style.checkboxWrapper">
      <Checkbox
        v-model="menuBadge.displayMenuBadge"
        input-id="displayMenuBadge"
        name="displayMenuBadge"
        :binary="true"
      />
      <label for="displayMenuBadge" class="ml-2">Display menu badge</label>
    </div>
    <div v-if="menuBadge.displayMenuBadge" :class="[{ [$style.nestedInput]: !isReadOnlyMode }, $style.wrapper]">
      <label v-if="!isReadOnlyMode" for="badgeMenuIcon">Associated icon *</label>
      <InputGroup>
        <InputGroupAddon>
          <VdIcon store="fas" name="seal" size="large"></VdIcon>
        </InputGroupAddon>
        <InputText
          id="badgeMenuIcon"
          v-model="menuBadge.menuBadgeIcon"
          :disabled="isReadOnlyMode"
          @keydown="handleKeyDown"
        />
      </InputGroup>
      <div v-if="!isValidBadgeIcon" :class="$style.error">Badge icon is invalid</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { prohibitInput } from "@/utils/prohibitInput";
import Checkbox from "primevue/checkbox";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputText from "primevue/inputtext";
import { computed, reactive, watch } from "vue";

const props = defineProps({
  menuBadgeIcon: {
    type: String,
    default: "",
  },
  displayMenuBadge: {
    type: Boolean,
    default: false,
  },
  canEditDisplayMenuBadge: {
    type: Boolean,
    default: false,
  },
  showMenuBadgeDisplayCheckbox: {
    type: Boolean,
    default: false,
  },
  canEditMenuBadgeDisplayCountDown: {
    type: Boolean,
    default: false,
  },
  isValidBadgeIcon: {
    type: Boolean,
    default: true,
  },
});

const menuBadge = reactive({
  displayMenuBadge: props.displayMenuBadge,
  menuBadgeIcon: props.menuBadgeIcon,
});

const isReadOnlyMode = computed(() => !props.showMenuBadgeDisplayCheckbox);

const emits = defineEmits(["update"]);
watch(
  () => menuBadge,
  (newValue) => {
    emits("update", newValue);
  },
  { deep: true }
);

function handleKeyDown(event: KeyboardEvent) {
  prohibitInput(event, [" "]);
}
</script>

<style module>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  width: -webkit-fill-available;
}
.checkboxWrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 12px;
}

.nestedInput {
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.error {
  font-size: 12px;
  color: #f87171;
}
</style>
